export const config: any = {};

export const BANNER_STATUS: any = {
    teaser: 'teaser',
    activity: 'activity',
    end: 'end',
};

export const defaultConfig: any = {
    titleColor: '#ffffff',
    subtitleColor: '#ffffff',
    labelColor: '#FFBD3C',
    countdownBgColor: '#ffffff',
    countdownNumColor: '#F29100',
    countdownTextColor: '#AFAFAF',
    image: 'https://websiteoss.ecoflow.com/upload/image/1730283260835/md5__9e35b83cdca5fbacbe6e43be78de58d5.svg',
    mobileImage: 'https://websiteoss.ecoflow.com/upload/image/1730283260835/md5__9e35b83cdca5fbacbe6e43be78de58d5.svg',
    // image: 'https://websiteoss.ecoflow.com/upload/image/1729043117487/Group%201000007787.png',
    // mobileImage:
    //     'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1715330769839/%E5%AE%98%E7%BD%91%E9%A6%96%E9%A1%B5Banner-PC(%E6%AC%A7%E6%B4%B2-%E5%BE%AE%E9%80%86)_%201125_1500%20(1).png',
    learnMoreLinkColor_before: '#000000',
    learnMoreBtnColor_before: '#FFFFFF',
    learnMoreLinkColor_active: '#000000',
    learnMoreBtnColor_active: '#FFFFFF',
    signUpBtnColor: 'linear-gradient(270deg, #FFFCC3 8.31%, #FFBD3C 102.37%)',
    activityType: 'active',
    align: 'left',
    subscription: 'N',
    referralImg: 'https://websiteoss.ecoflow.com/upload/image/1730283260835/md5__9e35b83cdca5fbacbe6e43be78de58d5.svg',
    referralMobileImage: 'https://websiteoss.ecoflow.com/upload/image/1730283260835/md5__9e35b83cdca5fbacbe6e43be78de58d5.svg',
    // referralImg: 'https://websiteoss.ecoflow.com/upload/image/1730187396553/Gift.png',
    // referralMobileImage: 'https://websiteoss.ecoflow.com/upload/image/1730187642751/Group%201000007790.png',
    white: '#ffffff',
    black: '#000000',
    defaultLabel: '请输入活动标签',
    defaultTitle: '请输入活动主标题文案',
    defaultSubtitle: '请输入活动副标题文案',
};
